<ng-container *ngIf="viewModel$ | async as viewModel; else loading">
  <ng-container *ngIf="viewModel.promos.length > 0">
    <mat-checkbox *ngIf="canEdit()" (change)="toggleSelectAll($event.checked)" [checked]="isAllSelected()"
      [indeterminate]="isSomeSelectedOnPage() && !isAllSelected()">Select All</mat-checkbox>
    <div class="grid">
      <mat-card appearance="outlined" *ngFor="let promo of viewModel.promos; index as i">
        <mat-card-content>
          <span class="rank" *ngIf="promo?.Detail?.Rank">Rank : {{ promo?.Detail?.Rank }}</span>
          <div class="offer-status">
            <span [matMenuTriggerFor]="canEdit() ? menu : null" class="ellipsis-3-line {{ getStatusClass(promo) }}">
              {{ getStatusText(promo) }}
              <mat-icon *ngIf="canEdit()" class="icon">arrow_drop_down</mat-icon>
            </span>
          </div>
          <mat-menu #menu="matMenu" class="status-menu">
            <button type="button" mat-menu-item class="statusAPPROVED" [disabled]="promo?.Detail?.Status === 'APPROVED'"
              (click)="updateStatus(Status.APPROVED, promo)">
              APPROVED
            </button>
            <button type="button" mat-menu-item class="statusPENDING" [disabled]="promo?.Detail?.Status === 'PENDING'"
              (click)="updateStatus(Status.PENDING, promo)">
              PENDING
            </button>
            <button type="button" mat-menu-item class="statusSUPPRESSED"
              [disabled]="promo?.Detail?.Status === 'SUPPRESSED'" (click)="updateStatus(Status.SUPPRESSED, promo)">
              SUPPRESSED
            </button>
          </mat-menu>

          <div class="grid-col-span-2 offer-name" title="{{ promo.Detail.Name }}" fxLayout="row wrap"
            fxLayoutAlign="start start" fxLayoutGap="15px">
            <mat-checkbox *ngIf="!readOnlyMode" (click)="$event.stopPropagation()" fxFlex="30px" class="card-checkbox"
              (change)="toggleSelect($event.checked, promo)" [checked]="selection.isSelected(promo)">
            </mat-checkbox>
          </div>

          <div fxLayoutAlign="center center" class="offer-image">
            <img mat-card-md-image
              [src]="promo.FacingAsset ? (promo.FacingAsset | offerPreview: PreviewMode.Medium) : './assets/images/default-image.png'"
              alt="Offer image" (error)="onImageError($event)">
          </div>

          <div class="offer-content" fxLayout="column">
              <mat-form-field class="versions" appearance="outline">
                <mat-select [(value)]="promo.Detail.OfferVariantName" [disabled]="true" placeholder="Select Variant">
                  <mat-option [value]="promo.Detail.OfferVariantName">{{promo.Detail.OfferVariantName}}</mat-option>
                </mat-select>
              </mat-form-field>

            <div class="offer-headline">
              <span [innerHtml]="promo?.PricingPreviewHtml"></span>
            </div>
          </div>

          <div class="card-footer grid-col-span-2" fxLayout="row wrap" fxLayoutGap="15px">
            <div class="card_footer_row">
              <div class="card_footer_col-1">
                <span title="{{ promo?.OfferTagNames }}" class="card-footer-text w-100">
                  Tags : {{ promo?.OfferTagNames }}
                </span>
                <span *ngIf="promo?.VersionNames; else noVersionAssigned"
                  title="{{ promo?.VersionNames }}" class="card-footer-text version-codes w-100">
                  Versions : {{ promo?.VersionNames }}
                </span>
                <ng-template #noVersionAssigned>
                  <span class="card-footer-text version-codes version-codes--missing w-100"
                    role="status" aria-label="No version assigned"
                    title="No version assigned">
                    <mat-icon class="version-warning-icon" aria-hidden="true">warning</mat-icon>
                    <span class="version-warning-text">No version assigned</span>
                  </span>
                </ng-template>
              </div>
              <div class="card_footer_col-center">
                <div *ngIf="promo?.Badge" class="badge-container">
                  <img mat-card-md-image
                    [src]="promo.Badge ? (promo.Badge | offerPreview: PreviewMode.Medium) : './assets/images/default-image.png'"
                    alt="Badge image" (error)="onImageError($event)">
                </div>
              </div>
              <div class="card_footer_col-2">
                <div class="page-position">
                  <span title="{{ promo?.PageNumber }}" class="card-footer-text w-100">
                    Page: {{ promo?.PageNumber }}
                  </span>
                  <span title="{{ promo?.Position }}" class="card-footer-text version-codes w-100">
                    Position: {{ promo?.Position }}
                  </span>
                </div>
              </div>
            </div>

            <div class="card-footer-text">
              <span class="footer-text">{{ promo?.EventOfferType }}</span>
              <span class="footer-text display">Client Key: <span
                   title="{{ promo?.Detail?.ClientKey }}">{{promo?.Detail?.ClientKey }}</span>
              </span>
            </div>

            <div class="card-footer-btns">
              <button class="offer-button" type="button" mat-button color="accent" (click)="onEdit(promo.Detail.Id)">
                <span *ngIf="canEdit()">Edit</span>
                <span *ngIf="!canEdit()">View Details</span>
              </button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </ng-container>

  <ng-container *ngIf="viewModel?.promos?.length === 0">
    <table>
      <tr>
        <td class="no-records">
          <h2>No Records Found</h2>
        </td>
      </tr>
    </table>
  </ng-container>
</ng-container>

<ng-template #loading>
  <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
</ng-template>
